import feedbackApi, { FeedbackRequestData } from '@api/feedback'
import { makeMutation } from '@lib/mutation'

export const useFeedbackMutation = makeMutation<FeedbackRequestData, void>({
  key: 'feedback',
  loader: async params => await feedbackApi.send(params),
})
